import * as React from 'react';
import { useSelector } from 'react-redux';
import { useEventCallback } from '@cian/react-utils';
import { Button } from '@cian/ui-kit';
import { PhoneButtonContainer } from '../PhoneButtonContainer';
import { trackPhoneOpen } from '../../utils/analytics';
import { selectProjectId } from '../../selectors';
import { SidebarContactsInfo } from '../../components/SidebarContactsInfo';

export const SidebarContactsContainer = () => {
  const projectId = useSelector(selectProjectId);

  const handleShowContacts = useEventCallback(() => {
    trackPhoneOpen('Open_CSP_card_floating_block', projectId);
  });

  return (
    <PhoneButtonContainer
      button={<Button fullWidth>Показать телефон</Button>}
      contentRenderer={phone => <SidebarContactsInfo phone={phone} />}
      onShow={handleShowContacts}
    />
  );
};
